<script>
export default {
  data() {
    return {
      sendingFriendRequest: false
    };
  },
  computed: {
    authCustomerProfile() {
      let user = this.$store.getters["user/me"];
      return user ? user.customer_profile : null;
    },
    friendRequest() {
      if (!this.authCustomerProfile) {
        return null;
      }

      let friendRequests = this.authCustomerProfile.sent_friend_requests
        .concat(this.authCustomerProfile.customer_profile_friends)
        .sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });

      return friendRequests.find(friendRequest => {
        return (
          friendRequest.customer_profile_id1 === this.otherId ||
          friendRequest.customer_profile_id2 === this.otherId
        );
      });
    },
    friendRequestSent() {
      return (
        this.authCustomerProfile &&
        this.friendRequest &&
        this.friendRequest.customer_profile_id1 ===
          this.authCustomerProfile.id &&
        this.friendRequest.accepted === null
      );
    },
    friendRequestReceived() {
      return (
        this.authCustomerProfile &&
        this.friendRequest &&
        this.friendRequest.customer_profile_id2 ===
          this.authCustomerProfile.id &&
        this.friendRequest.accepted === null
      );
    },
    areFriends() {
      return (
        this.authCustomerProfile &&
        this.friendRequest &&
        this.friendRequest.accepted === true
      );
    }
  },
  methods: {
    sendFriendRequest() {
      if (
        this.sendingFriendrequest ||
        this.areFriends ||
        this.friendRequestSent
      ) {
        return;
      }

      this.sendingFriendRequest = true;

      this.$http
        .post("/api/v1/friends", {
          customer_profile_id1: this.authCustomerProfile.id,
          customer_profile_id2: this.otherId
        })
        .then(() => {
          location.reload();
        })
        .finally(() => {
          this.sendingFriendRequest = false;
        })
        .catch(error => {
          this.$notify({
            title: error.response.data,
            type: "error"
          });
        });
    }
  }
};
</script>
